'use client';

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

interface SpinnerProps {
  size?: number;
  className?: string;
  fullScreen?: boolean;
  asCard?: boolean;
}

export default function Spinner({ size = 24, className = '', fullScreen = false, asCard = false }: SpinnerProps) {
  const antIcon = <LoadingOutlined style={{ fontSize: size }} spin />;

  if (fullScreen) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm z-50">
        <Spin indicator={antIcon} className={className} />
      </div>
    );
  }

  if (asCard) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <Spin indicator={antIcon} />
      </div>
    );
  }
  return (
    <div className={`flex items-center justify-center p-4 ${className}`}>
      <Spin indicator={antIcon} />
    </div>
  );
} 
